/** Title sx for plan grid task rows (week/day + dense month). */
import {
  planCalendarTaskTitleFontSize,
  FONT_WEIGHT_SEMIBOLD,
  FONT_WEIGHT_REGULAR,
  PLAN_LINE_HEIGHT_DEFAULT,
} from '@/components/ui/taskVisualTokens';

export const buildGridTaskTitleSx = (dense, completed, isMainTask) => ({
  flex: '1 1 auto',
  minWidth: 40,
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textDecoration: completed ? 'line-through' : 'none',
  color: completed ? 'text.subtle' : 'inherit',
  fontWeight: isMainTask ? FONT_WEIGHT_SEMIBOLD : FONT_WEIGHT_REGULAR,
  fontSize: planCalendarTaskTitleFontSize,
  // Dense row sx uses 1.15; bump title so two clamped lines do not collide.
  lineHeight: dense ? PLAN_LINE_HEIGHT_DEFAULT : undefined,
});
